<template>
    <form @submit.prevent="validate">
        <b-row id="futurocoin_transfer_component"
               class="futurocoin-transfer-component">
            <b-col lg="4" cols="12">
                <div class="form-item form-item-amount">
                    <div class="transfer-value" :class="{ 'field-error': (errors.has('withdraw_royal') || available < 0) && showErrors }">
                        <input type="text"
                               name="withdraw_royal"
                               v-validate
                               data-vv-rules="required|money|greaterThanZero"
                               data-vv-as="amount"
                               v-model="amount"
                               :disabled="progress">
                        <div class="currency">FTO</div>
                    </div>
                    <p class="field-error--description"
                       v-show="errors.has('withdraw_royal') && showErrors">{{ errors.first('withdraw_royal') }}</p>
                    <p class="field-error--description"
                       v-show="available < amount && showErrors">Not enough founds</p>
                </div>
            </b-col>
            <b-col lg="4" cols="12">
                <div class="transfer-get-all">
                    <p @click="withdrawAll()"
                       style="cursor: pointer">withdraw all available coins</p>
                </div>
            </b-col>
            <b-col lg="4" cols="12">
                <button class="button--primary"
                        :class="{ 'button--progress': progress }">Transfer to wallet</button>
            </b-col>
        </b-row>
    </form>
</template>

<script>
    export default {
        dependencies: ['money'],
        data () {
            return {
                amount: 0,
                progress: false,
                showErrors: false
            }
        },
        computed: {
            available () {
                return this.money.format(this.$store.getters.ftoAccounts.allowToWithdrawFromRoyal, 'fto');
            },
            confirm () {
                return this.$store.getters.modals.withdrawCoins.accept;
            },
            type () {
                return this.$store.getters.modals.withdrawCoins.type;
            }
        },
        methods: {
            withdrawAll () {
                this.amount = this.available
            },
            validate (e) {
                if (!this.progress) {
                    this.showErrors = false
                    this.$validator.validateAll().then(() => {
                        if (!this.errors.any() && Number(this.available) > 0 && Number(this.amount) <= Number(this.available)) {
                            this.$store.commit('modals', {
                                modal: 'withdrawCoins',
                                data: {
                                    visible: true,
                                    coins: this.amount,
                                    type: 'royal',
                                    accept: false
                                }
                            })
                        } else {
                            this.showErrors = true
                        }
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .futurocoin-transfer-component{
        margin: 0 -15px 30px;
    }

    .transfer-get-all{
        p{
            line-height: 42px;
        }
    }

    .button--primary{
        width: 100%;
    }

    @media(max-width:991px){
        .transfer-get-all p{
            line-height: 13px!important;
            margin-bottom: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/FuturocoinRoyalTransfer.vue